export default __webpack_public_path__ + "static/media/logo138x75white.f668ae3e.png";